export const PLAYER_VISUAL_RADIUS = 10;
export const PLAYER_HITBOX_RADIUS = PLAYER_VISUAL_RADIUS * 0.5;
export const PLAYER_MAX_SPEED = 1200;
export const PLAYER_ARROW_LENGTH = 15;

export const DOT_RADIUS = 8;
export const DOT_SPAWN_ANIMATION_DURATION = 1000;
export const DOT_SPAWN_SCALE_MAX = 1.5;

export const WEAPON_ORB_RADIUS = 20;
export const WEAPON_ORB_COUNT = 3;
export const WEAPON_ORB_MIN_SPACING = 100;

export const WRAP_ENABLED = true;

export const SCORE_KILL = 10;
export const SCORE_PATTERN_BONUS_MIN = 50;
export const SCORE_PATTERN_BONUS_MAX = 200;
export const SCORE_TIME_DIVISOR = 10;

export const DIFFICULTY_EASY_MAX_SCORE = 500;
export const DIFFICULTY_MEDIUM_MAX_SCORE = 1500;

export const PATTERN_SELECTION_INTERVAL = 8000;

export const COLOR_PLAYER = '#00FF00';
export const COLOR_PLAYER_ARROW = '#00CC00';
export const COLOR_DOT = '#FF0000';
export const COLOR_DOT_SPAWNING = '#FF6666';
export const COLOR_DOT_FROZEN = '#00FFFF';
export const COLOR_BACKGROUND = '#000000';

export const WEAPON_COLORS: Record<string, string> = {
  KINETIC_BOMB: '#FF6600',
  BLASTER: '#9900FF',
  ICE_BOMB: '#00CCFF',
  HOMING_MISSILE: '#FFFF00',
  NUCLEAR_BOMB: '#FF0000',
  ELECTRIC_BOMB: '#00FFFF',
  DOT_REPELLENT: '#808080',
  CHAINSAW: '#0066FF',
  FLAME_BURST: '#FF9900',
  TRIPLE_CANNON: '#FF00FF',
  FIREBALL_ORB: '#FF4500',
  TESLA_CANNON: '#00CCFF',
  WORMHOLE: '#8B00FF'
};

export const TARGET_FPS = 60;
export const FRAME_TIME = 1000 / TARGET_FPS;

// ============================================
// BOSS CONSTANTS
// ============================================
export const BOSS_RADIUS = 32;
export const BOSS_BASE_SPEED = 80;
export const BOSS_INVULNERABILITY_MS = 600;

// Boss colors (primary body color)
export const BOSS_COLORS: Record<string, string> = {
  SPEED_DEMON: '#FF6B1A',
  SHIELD_MOTHER: '#1A8CFF',
  MAGNET_LORD: '#B026FF',
  SPLITTER_KING: '#00E676',
};

// Boss display names
export const BOSS_NAMES: Record<string, string> = {
  SPEED_DEMON: 'Speed Demon',
  SHIELD_MOTHER: 'Shield Mother',
  MAGNET_LORD: 'Magnet Lord',
  SPLITTER_KING: 'Splitter King',
};

// Boss HP per type
export const BOSS_HP: Record<string, number> = {
  SPEED_DEMON: 3,
  SHIELD_MOTHER: 4,
  MAGNET_LORD: 3,
  SPLITTER_KING: 5,
};

// Boss effect parameters
export const SPEED_BOOST_MULT = 1.6;       // dots move 1.6x faster
export const MAGNET_PULL_RADIUS = 9999;     // pull from anywhere
export const MAGNET_PULL_FORCE = 90;        // additional homing speed
export const SPLITTER_BABY_LIFESPAN_MS = 8000;

// Splitter baby dot radius (smaller than normal)
export const DOT_BABY_RADIUS = 6;

// Visual colors for buffed dots
export const COLOR_DOT_SHIELDED = '#7DD3FC';
export const COLOR_DOT_SPEED_AURA = 'rgba(255, 107, 26, 0.35)';
export const COLOR_DOT_MAGNET_AURA = 'rgba(176, 38, 255, 0.35)';
export const COLOR_DOT_SPLIT_AURA = 'rgba(0, 230, 118, 0.35)';
